import { Component, Input } from '@angular/core';
import { AARData, COR_TYPE, RatingSummary } from '../../aar/aar.types'

@Component({
  selector: 'app-destination-type-variant',
  templateUrl: './destination-type-variant.component.html',
  styleUrls: ['./destination-type-variant.component.scss']
})
export class DestinationTypeVariantComponent {
  @Input({ required: true }) ratingSummary: RatingSummary
}
